import moment from 'moment';
import DatatableComponent from '../../helpers/DatatableComponent';
import React, { useEffect, useState } from "react";
import axios from "axios";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import { connect } from "react-redux";
import { AvatarGroup, CircularProgress, Tooltip, Avatar, Button, Dialog, DialogContent, DialogTitle, Link, Typography, IconButton } from "@mui/material";
import BasicMenu from "../../helpers/menu";
import JoditEditorExample from "../../helpers/JoditEditorExample";
import { errorToast, successToast } from "../../helpers/Notification";
import SubmitTaskReportDialog from '../../helpers/SubmitTaskReport';

const TasksReportPage = ({ location, SetSelectedMenu, loggedUser, resources, systemSettings }) => {
    const mainBackground = systemSettings?.mainBackground;

    const [count, setCount] = React.useState(0);
    const [team, setTeam] = useState([]);
    const [selectedResource, setSelectedResource] = useState("");
    const [period, setPeriodState] = React.useState({
        startDate: moment().startOf("W"),
        endDate: moment().endOf("W"),
    });
    const [dataToEdit, setDataToEdit] = React.useState({});
    const [validationErrors, setValidationErrors] = React.useState({});
    const [taskId, setTaskId] = useState(null);
    const [loading, setLoading] = React.useState(false);
    const formRef = React.useRef(null);
    const [openSubmitDialog, setOpenSubmitDialog] = useState(false);
    const [processedData, setProcessedData] = useState([]);
    const [viewChallenge, setViewChallenge] = React.useState(false);
    const [editChallenge, setEditChallenge] = React.useState(false);

    const handleSubmitSuccess = () => {
        setCount((prev) => prev + 1);
    };

    useEffect(() => {
        SetSelectedMenu({
            menu: "report/task",
            title: "Task Report"
        });
    }, []);

    const fetchResources = async () => {
        try {
            const data = await axios.get('api/resource/my-team');
            setTeam(data.data.data);
        } catch (error) {
        }
    };

    const updateTask = async () => {
        if (!taskId) return errorToast('Server error. Please try again later');

        setLoading(true);
        try {
            const response = await axios.post(`/api/task/update/${taskId}`, { overallStatus: dataToEdit.overallStatus });
            successToast('Task updated successfully');

            setEditChallenge(false);
            setDataToEdit({});
            setValidationErrors({});
        } catch (error) {
            setValidationErrors({ description: error.message });
        } finally {
            setLoading(false);
            onSuccess();
        }
    };

    const renderChallengeModal = () => (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>
                <JoditEditorExample
                    htmlContent={dataToEdit?.overallStatus || ""}
                    onBlur={(str) =>
                        setDataToEdit((prev) => ({
                            ...prev,
                            overallStatus: str.target.value,
                        }))
                    }
                />
                {validationErrors.overallStatus && (
                    <div style={{ color: "red", marginTop: "0.5rem" }}>
                        {validationErrors.overallStatus}
                    </div>
                )}
            </div>
        </div>
    );

    const form = (
        <form
            ref={formRef}
            onSubmit={(e) => {
                e.preventDefault();
                updateTask().then((response) => {
                    if (response.status === 200) {
                        successToast("Task updated successfully");
                        setEditChallenge(false);
                        setDataToEdit({});
                        setValidationErrors({});
                    } else {
                        setValidationErrors(response.data);
                    }
                }).catch((error) => {
                    setValidationErrors({ description: error.message });
                });
            }}
        >
            {renderChallengeModal()}
            <div className="px-2" style={{ display: "flex", marginTop: "1rem" }}>
                {loading ? (
                    <CircularProgress />
                ) : (
                    <>
                        <Button
                            variant="contained"
                            color="error"
                            onClick={() => {
                                setEditChallenge(false);
                                setDataToEdit({});
                                setValidationErrors({});
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            style={{ marginLeft: "5px" }}
                            variant="contained"
                            type="submit"
                            sx={{
                                backgroundColor: mainBackground,
                                "&:hover": {
                                    backgroundColor: mainBackground,
                                },
                            }}

                        >
                            Save
                        </Button>
                    </>
                )}
            </div>
        </form>
    );


    useEffect(() => {
        fetchResources();

    }, [count]);

    const updatePeriod = (newPeriod) => {
        setPeriodState(newPeriod);
        // processedData({ data: list });
    };


    const onSuccess = () => setCount((v) => v + 1);


    const columns = [
        {
            name: "name",
            label: "Task Name",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                ),
            },
        },
        {
            name: "taskInitiator.names",
            label: "Initiated By",
        },
        {
            name: "startDate",
            label: "Start Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
            },

        },
        {
            name: "endDate",
            label: "End Date",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => moment(value).format("DD/MM/YYYY"),
            },
        },

        {
            name: 'task_assignees',
            label: 'Assigned to',
            options: {
                customBodyRender: (value, tableMeta) => {
                    const rowData = tableMeta.rowData;
                    const task_assignees = rowData[5];
                    const downloadUrl = "your_download_url";

                    if (!task_assignees || task_assignees.length === 0) {
                        return "Unassigned";
                    }

                    const isMeAssigned = task_assignees?.some(
                        (assignee) => assignee.Resource.id === loggedUser?.Resource?.id
                    );

                    if (task_assignees.length === 1) {
                        const assigneeName = task_assignees[0].Resource.names;
                        return isMeAssigned ? "Me" : assigneeName;
                    }

                    if (task_assignees.length === 2) {
                        const assigneeNames = task_assignees.map((assignee) =>
                            assignee.Resource.id === loggedUser?.Resource?.id ? "Me" : assignee.Resource.names
                        );

                        return (
                            <Tooltip
                                title={
                                    <div>
                                        {assigneeNames.map((name, index) => (
                                            <div key={index}>{name}</div>
                                        ))}
                                    </div>
                                }
                                arrow={true}
                            >
                                <div className={'flex flex-start'}>
                                    <AvatarGroup
                                        sx={{
                                            display: 'inline-flex',
                                            '& .MuiAvatar-root': {
                                                width: 24,
                                                height: 24,
                                                fontSize: 12
                                            }
                                        }}
                                    >
                                        {task_assignees.map((assignee) => (
                                            <Avatar
                                                key={assignee.Resource.names}
                                                alt={assignee.Resource.names}
                                                src={assignee.Resource.profile ? `${downloadUrl}/${assignee.Resource.profile}` : undefined}
                                                sx={{ width: 24, height: 24 }}
                                            />
                                        ))}
                                    </AvatarGroup>
                                </div>
                            </Tooltip>
                        );
                    }

                    if (task_assignees.length > 2) {
                        const assigneeNames = task_assignees.map((assignee) =>
                            assignee.Resource.id === loggedUser?.Resource?.id ? "Me" : assignee.Resource.names
                        );

                        return (
                            <Tooltip
                                title={
                                    <div>
                                        {assigneeNames.map((name, index) => (
                                            <div key={index}>{name}</div>
                                        ))}
                                    </div>
                                }
                                arrow={true}
                            >
                                <AvatarGroup
                                    total={task_assignees.length}
                                    sx={{
                                        display: 'inline-flex',
                                        '& .MuiAvatar-root': {
                                            width: 24,
                                            height: 24,
                                            fontSize: 12
                                        }
                                    }}
                                >
                                    <Avatar
                                        alt={task_assignees[0].Resource.names}
                                        src={task_assignees[0].Resource.profile ? `${downloadUrl}/${task_assignees[0].Resource.profile}` : undefined}
                                        sx={{ width: 24, height: 24 }}
                                    />
                                    <Avatar
                                        alt={task_assignees[1].Resource.names}
                                        src={task_assignees[1].Resource.profile ? `${downloadUrl}/${task_assignees[1].Resource.profile}` : undefined}
                                        sx={{ width: 24, height: 24 }}
                                    />
                                </AvatarGroup>
                            </Tooltip>
                        );
                    }
                },
            }
        },
        {
            name: "status",
            label: "Task Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value) => (
                    <div dangerouslySetInnerHTML={{ __html: value }} />
                ),
            },
        },
        {
            name: "overallStatus",
            label: "Overall Status",
            options: {
                filter: true,
                sort: true,
                customBodyRender: (value, tableMeta) => (
                    <div>
                        {value ? (
                            <Link
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const projectName = tableMeta.rowData[1];
                                    setDataToEdit({ challenge: value, name: projectName });
                                    setViewChallenge(true);
                                }}
                                sx={{ textDecoration: 'underline', color: 'blue', cursor: 'pointer' }}
                            >
                                View Status
                            </Link>
                        ) : (
                            <span style={{ color: '#888' }}>No Overall Status</span>
                        )}
                        {viewChallenge && dataToEdit.challenge === value && (
                            <Dialog
                                open={viewChallenge}
                                maxWidth="xs"
                                fullWidth
                                onClose={() => setViewChallenge(false)}
                                PaperProps={{
                                    style: { padding: '1rem', borderRadius: '8px' },
                                }}
                            >
                                {/* <DialogTitle style={{ fontSize: '1rem' }}>
                                    <b>{dataToEdit.name ? `Overall Status for Task: ${dataToEdit.name}` : "Challenge"}</b>
                                </DialogTitle> */}
                                <DialogTitle>
                                    <div className={"flex items-center"}>
                                        <div className={"flex-grow font-bold text-lg"}>
                                            <b>{dataToEdit.name ? `Overall Status for Task: ${dataToEdit.name}` : "Challenge"}</b>
                                        </div>
                                        <IconButton onClick={() => setViewChallenge(false)}>
                                            <img
                                                src={require("assets/icons/close.svg").default}
                                                alt={"close"}
                                            />
                                        </IconButton>
                                    </div>
                                </DialogTitle>
                                <DialogContent>
                                    <div
                                        dangerouslySetInnerHTML={{ __html: dataToEdit.challenge }}
                                        style={{ fontSize: '0.9rem', color: '#333' }}
                                    />
                                </DialogContent>
                                <div style={{ textAlign: 'right', marginTop: '1rem' }}>
                                    <Button
                                        onClick={() => setViewChallenge(false)}
                                        sx={{
                                            color: 'primary.main',
                                            textTransform: 'none',
                                            fontWeight: 'normal',
                                        }}
                                    >
                                        Close
                                    </Button>
                                </div>
                            </Dialog>
                        )}
                    </div>
                ),
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                customBodyRender: (v) => (
                    <div>
                        <BasicMenu
                            extra={[
                                {
                                    label: "Edit Overall Status",
                                    icon: <i className="fas fa-pen text-sm"></i>,
                                    onClick: async () => {
                                        try {
                                            const response = await axios.get(`/api/task/details/${v}`);
                                            setDataToEdit(response.data.task);
                                            setTaskId(v);
                                            setEditChallenge(true);
                                        } catch (error) {
                                        } finally {
                                            setLoading(false);
                                        }
                                    },
                                },
                            ]}
                        />
                        {editChallenge && taskId === v && (
                            <Dialog open={editChallenge} maxWidth={'lg'} fullWidth={true} onClose={() => setEditChallenge(false)}>
                                <DialogTitle>
                                    Edit overallStatus for Task: {dataToEdit?.name || "Unknown Task"}
                                </DialogTitle>
                                <DialogContent>{form}</DialogContent>
                            </Dialog>
                        )}
                    </div>
                ),
            },
        },
    ];

    return (
        <div>
            <DatatableComponent
                columns={columns}
                pdf={true}
                excel={true}
                submitReport={true}
                searchfield={true}
                search={false}
                viewColumns={false}


                order={location.state?.order}
                url={
                    !period.startDate && !period.endDate
                        ? `/api/task/list/line-manager/${loggedUser?.Resource?.positionId}?count=${count}&&resourceId=${selectedResource}`
                        : `/api/report/tasks/line-manager/${loggedUser?.Resource?.positionId}?count=${count}&resourceId=${selectedResource}${period.startDate && period.endDate ? `&period=${JSON.stringify(period)}` : ''}`
                }

                processData={(data) => {
                    setProcessedData(data.data);
                    return data;
                }}
                onSubmitReport={() => {
                    setOpenSubmitDialog(true);
                }}

                title={
                    <div className="flex gap-4 items-center">
                        {/* From Date */}
                        <div className="flex items-center gap-2">
                            <label className="text-[#054163] font-medium">From</label>
                            <input
                                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                                type="date"
                                value={
                                    Date.parse(period?.startDate)
                                        ? moment(period?.startDate).format("YYYY-MM-DD")
                                        : ""
                                }
                                max={period.endDate}
                                onChange={(e) => {
                                    updatePeriod({
                                        ...period,
                                        startDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                                    });
                                }}
                            />
                        </div>

                        {/* To Date */}
                        <div className="flex items-center gap-2">
                            <label className="text-[#054163] font-medium">To</label>
                            <input
                                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                                type="date"
                                value={
                                    Date.parse(period?.endDate)
                                        ? moment(period?.endDate).format("YYYY-MM-DD")
                                        : ""
                                }
                                min={moment(period?.startDate).format("YYYY-MM-DD")}
                                onChange={(e) => {
                                    updatePeriod({
                                        ...period,
                                        endDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                                    });
                                }}
                            />
                        </div>

                        {/* Reset Date Button */}
                        {(period?.startDate || period?.endDate) && (
                            <button
                                className="text-blue-500 font-medium hover:underline"
                                onClick={async () => {
                                    try {
                                        // Reset the period state to default values
                                        updatePeriod({
                                            startDate: null,
                                            endDate: null,
                                        });

                                        // Fetch all tasks without filtering by date
                                        const response = await axios.get(
                                            `/api/task/list/line-manager/${loggedUser?.Resource?.positionId}?count=${count}&resourceId=${selectedResource}`
                                        );
                                        //   setList(response.data.data);
                                    } catch (error) {
                                    }
                                }}
                            >
                                Reset Date
                            </button>
                        )}

                        {/* Resource Selector */}
                        <select
                            className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                            value={selectedResource}
                            onChange={(e) => {
                                setSelectedResource(e.target.value);
                            }}
                        >
                            <option value="">Select</option>
                            {team.map((item) => (
                                <option key={item.id} value={item.id}>
                                    {item?.names}
                                </option>
                            ))}
                        </select>

                        {/* Reset Resource Button */}
                        {selectedResource && (
                            <button
                                className="text-blue-500 font-medium hover:underline"
                                onClick={() => {
                                    setSelectedResource("");
                                }}
                            >
                                Reset
                            </button>
                        )}
                    </div>
                }

            />

            <SubmitTaskReportDialog
                open={openSubmitDialog}
                onClose={() => setOpenSubmitDialog(false)}
                onSuccess={handleSubmitSuccess}
                SubmitGeneralForm={async (url, formData) => {
                    try {
                        const response = await axios.post(url, formData, {
                            headers: { "Content-Type": "multipart/form-data" },
                        });
                        return { status: response.status === 200, data: response.data };
                    } catch (error) {
                        return { status: false };
                    }
                }}

                startDate={moment(period.startDate).format("YYYY-MM-DD")}
                endDate={moment(period.endDate).format("YYYY-MM-DD")}
                loggedUser={loggedUser}
                resources={resources}
                processData={processedData}

            />
        </div>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(TasksReportPage);